module.exports = __webpack_public_path__ + "static/media/momentoWow.f3aaf386.webp";